import type { ComposerTranslation } from 'vue-i18n';
import type { HalloweenLocation } from '~/types/halloween/location';

type PossibleKeys =
  | 'forest_enemy'
  | 'cave_enemy'
  | 'forest_story'
  | 'cave_story'
  | 'cave_good'
  | 'cave_bad'
  | 'forest_good'
  | 'forest_bad'
  | string;

let cachedStoryConfig: Record<PossibleKeys, number[]> | null = null;
export default function loadStoryConfig(t: ComposerTranslation) {
  const storyConfigRaw = t('story_config');

  if (!storyConfigRaw || storyConfigRaw === 'story_config') {
    throw new Error('Story config not found');
  }

  const storyConfig =
    cachedStoryConfig ??
    (Object.fromEntries(
      storyConfigRaw
        .split(' ')
        .map((key) => key.trim())
        .filter(Boolean)
        .map((key) => {
          const [keyName, keyValue] = key.split('=');
          return [
            keyName,
            keyValue
              .split(',')
              .map((value) => value.trim())
              .filter(Boolean)
              .map((value) => parseInt(value, 10))
          ] as const;
        })
    ) as Record<PossibleKeys, number[]>);

  if (!cachedStoryConfig) cachedStoryConfig = storyConfig;

  const buildReplicas = (location: HalloweenLocation, type: 'story' | 'enemy' | 'good' | 'bad', index: number) => {
    const baseKey = `${location}_${type}`;
    const replicasCount = (storyConfig[baseKey] || [])[index] ?? 0;

    return Array(replicasCount)
      .fill(0)
      .map((_, replica) => t(`story_${baseKey}_t_${index}_${replica}`));
  };

  return { storyConfig, buildReplicas };
}
